<div class="tools-container">
  <h4 class="tools-title">{{ 'PRESENTER.LAYOUT.TITLE' | translate }}</h4>
  <div class="alignment-tools">
    <div class="alignment-buttons">
      <div class="alignment-group">
        <button class="alignment-btn" (click)="onAlignLeft()" [matTooltip]="'PRESENTER.LAYOUT.ALIGN_LEFT' | translate">
          <mat-icon>align_horizontal_left</mat-icon>
        </button>

        <button
          class="alignment-btn"
          (click)="onAlignHorizontalCenter()"
          [matTooltip]="'PRESENTER.LAYOUT.ALIGN_HORIZONTAL_CENTER' | translate"
        >
          <mat-icon>align_horizontal_center</mat-icon>
        </button>

        <button
          class="alignment-btn"
          (click)="onAlignRight()"
          [matTooltip]="'PRESENTER.LAYOUT.ALIGN_RIGHT' | translate"
        >
          <mat-icon>align_horizontal_right</mat-icon>
        </button>
      </div>

      <div class="alignment-group">
        <button class="alignment-btn" (click)="onAlignTop()" [matTooltip]="'PRESENTER.LAYOUT.ALIGN_TOP' | translate">
          <mat-icon>vertical_align_top</mat-icon>
        </button>

        <button
          class="alignment-btn"
          (click)="onAlignVerticalCenter()"
          [matTooltip]="'PRESENTER.LAYOUT.ALIGN_VERTICAL_CENTER' | translate"
        >
          <mat-icon>vertical_align_center</mat-icon>
        </button>

        <button
          class="alignment-btn"
          (click)="onAlignBottom()"
          [matTooltip]="'PRESENTER.LAYOUT.ALIGN_BOTTOM' | translate"
        >
          <mat-icon>vertical_align_bottom</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="tools-container" [formGroup]="toolsFormGroup">
    <div class="form-field-row">
      <mat-form-field>
        <mat-label>{{ 'PRESENTER.LAYOUT.WIDTH' | translate }}</mat-label>
        <input matInput type="number" [formControl]="widthControl" min="8" max="200" />
        <span matTextSuffix>%</span>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'PRESENTER.LAYOUT.HEIGHT' | translate }}</mat-label>
        <input matInput type="number" [formControl]="heightControl" min="8" max="200" />
        <span matTextSuffix>%</span>
      </mat-form-field>
    </div>
  </div>

  <h4 class="tools-title">{{ 'PRESENTER.LAYERS' | translate }}</h4>

  <gb-presenter-tools-elevation
    (bringToFront)="onBringToFront()"
    (bringForward)="onBringForward()"
    (sendBackward)="onSendBackward()"
    (sendToBack)="onSendToBack()"
  >
  </gb-presenter-tools-elevation>
</div>
